<template>
  <div class="default-modal order-reject-modal">
    <el-dialog :model-value="visible" width="82%" top="4vh" class="order-reject-dialog-wrapper"
      custom-class="order-reject-dialog" :destroy-on-close="true" @close="onClose">
      <div class="dialog-header">
        <span class="header-part">{{ dialogTitle }}</span>
        <el-button size="medium" class="el-white" type="info" plain @click="onClose">
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>
      <div v-if="activationSummary" class="order-activation-summary">
        {{ activationSummary }}
      </div>
      <div class="order-reject-summary">
        <div>
          <span class="summary-label">Order</span>
          <span class="summary-value">{{ orderData && orderData.order_id ? orderData.order_id : '--' }}</span>
        </div>
        <div>
          <span class="summary-label">Patient</span>
          <span class="summary-value">{{ patientName }}</span>
        </div>
        <div>
          <span class="summary-label">Status</span>
          <el-tag :type="statusTagType">{{ orderData && orderData.status ? orderData.status : '--' }}</el-tag>
        </div>
      </div>

      <div v-if="loading" class="order-reject-loading">
        Loading case types and tubes...
      </div>
      <div v-if="isSubmitPending" class="order-reject-submit-loading" role="status">
        <i class="el-icon-loading" aria-hidden="true"></i>
        {{ isActivationMode ? "Activating order..." : "Rejecting order..." }}
      </div>
      <template v-else>
        <div class="order-reject-toolbar">
          <el-checkbox :model-value="allCaseTypesSelected"
            :indeterminate="someCaseTypesSelected && !allCaseTypesSelected" @change="toggleAllCaseTypes">
            {{ isActivationMode ? "Activate all case types" : "Reject all case types" }}
          </el-checkbox>
          <el-radio-group v-if="!isActivationMode" v-model="reasonMode" size="small">
            <el-radio-button label="same">Same reason for selected case types</el-radio-button>
            <el-radio-button label="different">Different reason per case type</el-radio-button>
          </el-radio-group>
        </div>

        <!-- <div v-if="reasonMode === 'same'" class="same-reason-panel">
          <el-select v-model="commonReason" placeholder="Select rejection reason" filterable allow-create
            default-first-option style="width: 360px" @change="applyCommonReason">
            <el-option v-for="reason in rejectionReasonOptions" :key="reason" :label="reason" :value="reason" />
          </el-select>
        </div> -->
        <div v-if="reasonMode === 'same'" class="same-reason-panel">
          <div style="flex:1; display:flex; flex-direction:column;">
            <label>Common Case Rejection Reason</label>
            <el-select v-model="commonCaseReason" placeholder="Select case rejection reason" clearable
              @change="applyCommonCaseReason">
              <el-option v-for="reason in caseRejectionReasonOptions" :key="reason.value" :label="reason.label"
                :value="reason.value" />
            </el-select>
          </div>
          <div style="flex:1; display:flex; flex-direction:column;">
            <label>Common Tube Rejection Reason</label>

            <el-select v-model="commonTubeReason" placeholder="Select tube rejection reason" clearable
              @change="applyCommonTubeReason">
              <el-option v-for="reason in tubeRejectionReasonOptions" :key="reason.value" :label="reason.label"
                :value="reason.value" />
            </el-select>
          </div>
        </div>
        <el-table :data="caseTypeRows" row-key="key" border max-height="500" class="order-reject-table"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }">
          <el-table-column width="48" fixed="left">
            <template #default="scope">
              <el-checkbox :model-value="isCaseTypeSelected(scope.row.key)"
                :disabled="isCaseTypeToggleDisabled(scope.row.case_type)"
                @change="(val) => toggleCaseType(scope.row.key, val)" />
            </template>
          </el-table-column>
          <el-table-column label="Case Type" min-width="170" fixed="left">
            <template #default="scope">
              <div class="case-type-name">{{ formatCaseType(scope.row.case_type) }}</div>
              <el-tag v-if="scope.row.is_sendout" size="small">Sendout</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Case Rejection Details" min-width="500">
            <template #default="scope">
              <div v-if="caseRejectionMap[scope.row.key]" class="case-rejection-details">
                <!-- Rejection Reason -->
                <div v-if="!isActivationMode" class="case-detail-field">
                  <label>Rejection Reason</label>

                  <el-select v-model="caseRejectionMap[scope.row.key].reason" placeholder="Select rejection reason"
                    clearable :disabled="!isCaseTypeSelected(scope.row.key) ||
                      reasonMode === 'same'
                      " @change="handleCaseReasonChange(scope.row.key)">
                    <el-option v-for="reason in caseRejectionReasonOptions" :key="reason.value" :label="reason.label"
                      :value="reason.value" />
                  </el-select>
                </div>
                <div v-else class="case-detail-field">
                  <label>Existing Rejection Reason</label>
                  <el-input :model-value="getExistingCaseRejectionReason(scope.row.case_type)" type="textarea" :rows="2"
                    readonly placeholder="--" />
                </div>

                <!-- Recommended Action -->
                <div v-if="!isActivationMode" class="case-detail-field">
                  <label>Recommended Action</label>

                  <el-input :model-value="caseRejectionMap[scope.row.key].comment" type="textarea" :rows="2" readonly
                    placeholder="Recommended action" />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Tube-Level Rejection" min-width="280">
            <template #default="scope">
              <div v-if="getCaseTypeTubes(scope.row.key).length" class="tube-rejection-list">
                <div v-for="tube in getCaseTypeTubes(scope.row.key)" :key="tube.tubeKey" class="tube-rejection-row">
                  <el-checkbox :model-value="isTubeSelected(scope.row.key, tube.tubeKey)"
                    :disabled="isTubeToggleDisabled(tube, scope.row.case_type)"
                    @change="(val) => toggleTube(scope.row.key, tube.tubeKey, val)">
                    <span class="tube-name">
                      {{ tube.tube_name }}
                      <el-tag v-if="getTubeRejectionState(tube, scope.row.case_type).partial" size="small"
                        type="warning">
                        PARTIAL
                      </el-tag>
                      <el-tag v-else-if="getTubeRejectionState(tube, scope.row.case_type).rejected" size="small"
                        type="danger">
                        REJECTED
                      </el-tag>
                    </span>
                    <div v-if="getTubeRejectionState(tube, scope.row.case_type).rejectedCodes.length"
                      class="rejected-tests">
                      <span class="rejected-tests-label">Already rejected:</span>
                      <el-tag v-for="code in getTubeRejectionState(tube, scope.row.case_type).rejectedCodes" :key="code"
                        size="small" type="danger">
                        {{ code }}
                      </el-tag>
                    </div>
                  </el-checkbox>

                  <el-select v-if="!isActivationMode" v-model="caseRejectionMap[scope.row.key].tubes[tube.tubeKey].reason"
                    placeholder="Select reason" class="tube-reason-select"
                    :disabled="!isTubeSelected(scope.row.key, tube.tubeKey) || reasonMode === 'same'"
                    @change="handleTubeReasonChange(scope.row, tube)">
                    <el-option v-for="reason in tubeRejectionReasonOptions" :key="reason.value" :label="reason.label"
                      :value="reason.value" />
                  </el-select>
                  <span v-else class="tube-existing-reason">
                    Existing: {{ getExistingTubeRejectionReason(tube, scope.row.case_type) || "--" }}
                  </span>
                </div>
              </div>
              <span v-else class="empty-text">No tube information available</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="order-reject-comment">
          <label>Additional Comment</label>
          <el-input v-model="comment" type="textarea" :rows="3"
            :placeholder="isActivationMode ? 'Add optional comments for activation' : 'Add optional rejection comments'" />
        </div>

        <!-- <div class="order-reject-attachments">
          <label>Attachment <span class="text-danger">*</span></label> -->
        <!-- <el-upload class="order-reject-upload" :auto-upload="false" :file-list="attachmentFileList"
            :on-change="handleAttachmentChange" :on-remove="handleAttachmentRemove" :limit="1" required>
            <el-button class="btn button-with-icon" type="primary">
              Add Attachment
            </el-button>
            <template #tip>
              <div class="el-upload__tip">Upload one rejection image.</div>
            </template>
          </el-upload> -->
        <div class="order-reject-attachments">
          <label>Attachment <span class="text-danger">*</span></label>

          <!-- <el-upload class="order-reject-upload" :auto-upload="false" :limit="1" :file-list="attachmentFileList"
            accept="image/*,.jpg,.jpeg,.png,.avif,.webp,.gif" :on-change="handleAttachmentChange"
            :on-remove="handleAttachmentRemove">
            <el-button type="primary">
              Add Attachment
            </el-button>

            <template #tip>
              <div class="el-upload__tip">
                Upload one rejection image.
                Allowed formats: JPG, JPEG, PNG, AVIF, WEBP, GIF.
              </div>
            </template>
          </el-upload> -->
          <el-upload action="#" list-type="picture-card" :auto-upload="false" :file-list="attachmentFileList" :limit="5"
            accept="image/*" :multiple="true" :on-change="handleImageChange" :on-remove="handleImageRemove"
            :before-upload="validateImageUpload" :on-exceed="handleImageLimit">
            <i class="el-icon-plus"></i>

            <template #tip>
              <div class="el-upload__tip">
                Upload at least 1 image. Maximum 5 images allowed.
              </div>
            </template>
          </el-upload>
        </div>
        <!-- </div> -->

        <div v-if="validationError" class="order-reject-error">
          {{ validationError }}
        </div>
      </template>

      <template #footer>
        <div class="dialog-footer">
          <el-button class="blue-cancel-button" plain @click="onClose">CANCEL</el-button>
          <el-button class="blue-save-button" :loading="isSubmitPending" :disabled="loading ||
            isSubmitPending ||
            !isRejectFormValid
            " @click="submitReject">
            {{ submitLabel }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import caseConstants from "@/config/constants/caseConstants";


const CASE_REJECTION_REASONS = [
  {
    value: "Insufficient sample received",
    label: "Insufficient sample received",
  },
  {
    value: "Incorrect specimen received",
    label: "Incorrect specimen received",
  },
  {
    value: "Turnaround time",
    label: "Turnaround time",
  },
  {
    value: "Specimen received without requisition",
    label: "Specimen received without requisition",
  },
  {
    value: "Early collection",
    label: "Early collection",
  },
  {
    value: "Only requisition received without sample",
    label: "Only requisition received without sample",
  },
  {
    value: "Sample has leaked in transit",
    label: "Sample has leaked in transit",
  },
  {
    value: "Hemolyzed or clotted specimen",
    label: "Hemolyzed or clotted specimen",
  },
  {
    value: "Invalid insurance",
    label: "Invalid insurance",
  },
  {
    value: "Inactive insurance",
    label: "Inactive insurance",
  },
  {
    value: "Invalid ICD codes",
    label: "Invalid ICD codes",
  },
  {
    value: "The date of collection is missing in the requisition",
    label: "The date of collection is missing in the requisition",
  },
  {
    value: "ICD codes are missing in the requisition",
    label: "ICD codes are missing in the requisition",
  },
  {
    value: "The test is not marked correctly",
    label: "The test is not marked correctly",
  },
  {
    value: "Specimen and test mismatch",
    label: "Specimen and test mismatch",
  },
  {
    value: "Medications are needed",
    label: "Medications are needed",
  },
  {
    value: "Insurance details are missing",
    label: "Insurance details are missing",
  },
  {
    value: "There is a billing mismatch",
    label: "There is a billing mismatch",
  },
  {
    value: "Others",
    label: "Others",
  },
];

const TUBE_REJECTION_REASONS = [
  {
    value: "Specimen Not Received",
    label: "Specimen Not Received",
  },
  {
    value: "Insufficient Quantity",
    label: "Insufficient Quantity",
  },
  {
    value: "Hemolyzed",
    label: "Hemolyzed",
  },
  {
    value: "Clotted Sample",
    label: "Clotted Sample",
  },
  {
    value: "Sample Leaked During Transportation",
    label: "Sample Leaked During Transportation",
  },
  {
    value: "Incorrect Specimen Container",
    label: "Incorrect Specimen Container",
  },
  {
    value: "Incorrect Specimen Received",
    label: "Incorrect Specimen Received",
  },
  {
    value: "Label Mismatch Identified",
    label: "Label Mismatch Identified",
  },
  {
    value: "Specimen and Test Mismatch",
    label: "Specimen and Test Mismatch",
  },
  {
    value: "Improper Specimen Storage",
    label: "Improper Specimen Storage",
  },
  {
    value: "Specimen Expired",
    label: "Specimen Expired",
  },
  {
    value: "Contaminated Specimen",
    label: "Contaminated Specimen",
  },
  {
    value: "Other",
    label: "Other",
  },
];
const REASON_TO_ACTION_MAP = {
  "Insufficient sample received":
    "Please provide a specimen with sufficient quantity for processing the test.",

  "Incorrect specimen received":
    "Please provide the correct specimen type related to the test ordered.",

  "Turnaround time":
    "Please minimize the time delay between specimen collection and specimen receipt.",

  "Specimen received without requisition":
    "Please provide the requisition form to process the testing.",

  "Only requisition received without sample":
    "Please provide the sample for test processing along with the updated requisition.",

  "Sample has leaked in transit":
    "Please provide a fresh sample to process the test.",

  "Hemolyzed or clotted specimen":
    "Please recollect the sample as it needs to be in proper condition for testing.",

  "Invalid insurance":
    "Please provide valid insurance details along with a copy of the insurance.",

  "Inactive insurance":
    "Please provide active insurance details along with a copy of the insurance.",

  "Invalid ICD codes":
    "Please provide valid ICD codes to process the test.",

  "The date of collection is missing in the requisition":
    "We need the date of collection to process the test.",

  "ICD codes are missing in the requisition":
    "Please provide the ICD code for test processing.",

  "The test is not marked correctly":
    "We need an updated requisition to process the testing.",

  "Specimen and test mismatch":
    "The specimen and requisition are incompatible.",

  "Medications are needed":
    "We require the medications for test processing.",

  "Insurance details are missing":
    "Please provide the insurance details and a copy of the insurance card.",

  "There is a billing mismatch":
    "The bill-to information is marked incorrectly.",
};
export default {
  name: "OrderRejectDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderData: {
      type: Object,
      default: () => ({}),
    },
    tubeInfo: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    caseRejectionReasons: {
      type: Array,
      default: () => CASE_REJECTION_REASONS,
    },

    tubeRejectionReasons: {
      type: Array,
      default: () => TUBE_REJECTION_REASONS,
    },

    mode: {
      type: String,
      default: "reject",
    },
  },
  emits: ["close", "submit"],
  data() {
    return {
      reasonMode: "different",
      commonCaseReason: "",
      commonTubeReason: "",
      selectedCaseMap: {},
      caseRejectionMap: {},
      comment: "",
      attachmentFileList: [],
      validationError: "",
      submitPending: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      reasonToActionMap: REASON_TO_ACTION_MAP,
    };
  },
  computed: {
    isActivationMode() {
      return this.mode === "activate";
    },
    dialogTitle() {
      return this.isActivationMode
        ? "Activate Partially Rejected Order"
        : "Reject Order";
    },
    submitLabel() {
      return this.isActivationMode
        ? "ACTIVATE ORDER"
        : "REJECT ORDER";
    },
    activationSummary() {
      if (!this.isActivationMode) return "";
      const state = this.rejectionState || { cases: {}, tubes: {} };
      const caseCount = Object.keys(state.cases || {}).filter(
        (k) => state.cases[k].rejected
      ).length;
      const tubeCount = Object.keys(state.tubes || {}).length;
      return `This order was partially rejected. Select the tests/tubes below to reactivate them. Rejected case types: ${caseCount}, rejected tubes: ${tubeCount}.`;
    },
    caseRejectionReasonOptions() {
      return this.caseRejectionReasons?.length
        ? this.caseRejectionReasons
        : CASE_REJECTION_REASONS;
    },
    hasSelectedTubes() {
      return Object.values(this.caseRejectionMap).some(
        (caseData) =>
          Object.values(caseData.tubes || {}).some(
            (tube) => tube.rejected
          )
      );
    },
    tubeRejectionReasonOptions() {
      return this.tubeRejectionReasons?.length
        ? this.tubeRejectionReasons
        : TUBE_REJECTION_REASONS;
    },
    patientName() {
      const patient = this.orderData?.patient_info || {};
      const name = `${patient.first_name || ""} ${patient.last_name || ""}`.trim();
      return name || "--";
    },
    statusTagType() {
      const status = this.orderData?.status;
      const statusMap = {
        ACTIVE: "default",
        PARTIAL: "info",
        REJECTED: "darkDanger",
        PARTIALLY_REJECTED: "darkDanger",
        COMPLETED: "success",
        ARCHIVED: "danger",
      };
      return statusMap[status] || "";
    },
    accessionedCaseTypeKeys() {
      return new Set(
        (this.orderData?.accession_data || [])
          .map((accession) => accession?.case_type)
          .filter(Boolean)
      );
    },
    isRejectFormValid() {
      if (this.isActivationMode) {
        const hasSelection =
          !!(
            this.selectedCaseTypeKeys.length ||
            this.hasSelectedTubes
          );

        const fileCount =
          this.attachmentFileList.length;

        return (
          hasSelection &&
          fileCount >= 1 &&
          fileCount <= 5
        );
      }

      if (
        !this.selectedCaseTypeKeys.length &&
        !this.hasSelectedTubes
      ) {
        return false;
      }

      // Attachment is mandatory
      const attachment =
        this.attachmentFileList?.[0]?.raw;

      if (!attachment || !this.isValidImageFile(attachment)) {
        return false;
      }

      // Every selected case requires a case reason
      for (const key of this.selectedCaseTypeKeys) {
        const caseData =
          this.caseRejectionMap[key];

        if (!caseData?.reason) {
          return false;
        }
      }

      // Every selected tube requires a tube reason
      for (const caseData of Object.values(
        this.caseRejectionMap
      )) {
        for (const tube of Object.values(
          caseData.tubes || {}
        )) {
          if (tube.rejected && !tube.reason) {
            return false;
          }
        }
      }

      return true;
    },
    rejectionState() {
      return this.normalizeRejectionData();
    },

    rejectedCaseTypeKeys() {
      const state = this.rejectionState || { cases: {} };
      return new Set(
        Object.keys(state.cases || {}).filter(
          (caseType) => state.cases[caseType].rejected
        )
      );
    },

    isTubePartiallyRejected(tube) {
      const tubeId =
        tube?.tube_id || tube?._id;

      if (!tubeId) {
        return false;
      }
      return !!this.rejectionState.tubes[tubeId];
    },
    caseTypeRows() {
      if (this.isActivationMode) {
        return this.buildActivationCaseTypeRows();
      }

      const seen = new Map();

      for (const tube of this.tubeInfo || []) {
        for (const test of tube.tests || []) {
          const caseTypes = Array.isArray(test.case_type)
            ? test.case_type
            : test.case_type
              ? [test.case_type]
              : [];

          const orderCode = this.getTestOrderCode(test);

          // Skip tests which are already rejected
          // or already have an accession created.
          if (!orderCode || !this.isOrderCodeActive(orderCode)) {
            continue;
          }

          for (const caseType of caseTypes) {
            const isSendout = test.is_sendout === true;

            const key = this.getCaseTypeKey(
              caseType,
              isSendout
            );

            if (!seen.has(key)) {
              seen.set(key, {
                key,
                case_type: caseType,
                is_sendout: isSendout,
              });
            }
          }
        }
      }

      return Array.from(seen.values());
    },
    selectedCaseTypeKeys() {
      return Object.keys(this.selectedCaseMap).filter((key) => this.selectedCaseMap[key]);
    },
    allCaseTypesSelected() {
      return this.caseTypeRows.length > 0 && this.caseTypeRows.every((row) => this.selectedCaseMap[row.key]);
    },
    someCaseTypesSelected() {
      return this.caseTypeRows.some((row) => this.selectedCaseMap[row.key]);
    },
    isSubmitPending() {
      return this.submitting || this.submitPending;
    },
  },
  watch: {
    reasonMode(newMode, oldMode) {
      if (newMode === oldMode) {
        return;
      }

      if (newMode === "same") {
        if (this.commonCaseReason) {
          this.applyCommonCaseReason();
        }

        if (this.commonTubeReason) {
          this.applyCommonTubeReason();
        }
      }

      if (newMode === "different") {
        // Intentionally do nothing.
        //
        // caseData.reason and tube.reason already contain
        // the previous values.
        //
        // The UI becomes editable because :disabled changes.
      }
    },

    commonCaseReason() {
      if (this.reasonMode === "same") {
        this.applyCommonCaseReason();
      }
    },

    commonTubeReason() {
      if (this.reasonMode === "same") {
        this.applyCommonTubeReason();
      }
    },

    visible: {
      immediate: true,
      handler(isVisible) {
        if (isVisible) {
          this.initializeForm();
        } else {
          this.submitPending = false;
        }
      },
    },
    submitting(isSubmitting) {
      if (!isSubmitting) {
        this.submitPending = false;
      }
    },
    tubeInfo: {
      deep: true,
      handler() {
        if (this.visible) {
          this.initializeForm();
        }
      },
    },
    orderData: {
      immediate: true,
      deep: true,
      handler(newOrderData) {
        console.log(
          "ORDER REJECT issues:",
          newOrderData?.samples_with_issues
        );
      },
    },
  },
  methods: {
    getCaseTypeKey(caseType, isSendout) {
      return `${caseType}_${isSendout ? "sendout" : "normal"}`;
    },
    formatCaseType(caseType) {
      return this.caseTypeMap[caseType] || caseType;
    },
    isOrderCodeAccessionCreated(orderCode) {
      const accessionData = this.orderData?.accession_data || [];

      return accessionData.some((accession) =>
        Array.isArray(accession?.order_codes) &&
        accession.order_codes.includes(orderCode)
      );
    },
    handleCaseReasonChange(caseTypeKey) {
      const caseData =
        this.caseRejectionMap[caseTypeKey];

      if (!caseData) {
        return;
      }

      const selectedReason =
        caseData.reason;

      caseData.comment =
        this.reasonToActionMap[
        selectedReason
        ] || "";

      this.syncTubeReasons(caseTypeKey);
    },
    handleTubeReasonChange(row, tube) {
      const tubeData =
        this.caseRejectionMap[row.key]
          ?.tubes?.[tube.tubeKey];

      if (!tubeData) {
        return;
      }

      const reason = tubeData.reason;

      /*
       * Tube-level reason should update
       * the case-level recommended action.
       *
       * If you have multiple tubes with
       * different reasons, the last selected
       * reason will be reflected.
       */
      this.caseRejectionMap[row.key].comment =
        this.getActionForReason(reason);
    },
    isRestrictedPending(code) {
      return this.restrictedPendingSet.has(code);
    },
    handleImageChange(file, fileList) {
      this.attachmentFileList =
        fileList.slice(0, 5);

      this.validationError = "";
      this.submitPending = false;
    },

    handleImageRemove(file, fileList) {
      this.attachmentFileList =
        fileList;
    },

    handleImageLimit() {
      this.$message.warning(
        "You can upload a maximum of 5 images."
      );
    },

    validateImageUpload(file) {
      const isImage =
        file.type &&
        file.type.startsWith("image/");

      if (!isImage) {
        this.$message.error(
          "Only image files are allowed."
        );

        return false;
      }

      return true;
    },
    isOrderCodeActive(orderCode) {
      return (
        !this.isOrderCodeRejected(orderCode) &&
        !this.isOrderCodeAccessionCreated(orderCode)
      );
    },
    isOrderCodeRejected(orderCode) {
      const state = this.rejectionState || {};
      // Legacy samples_with_issues data
      const legacy = new Set(
        (this.orderData?.samples_with_issues || [])
          .filter(
            (issue) =>
              String(issue?.status || "").toUpperCase() === "REJECTED"
          )
          .flatMap((issue) => issue?.order_codes || [])
          .filter(Boolean)
      );
      if (legacy.has(orderCode)) return true;

      // order_rejection_data entries (case level or tube level)
      const rejections =
        this.orderData?.order_rejection_data || [];
      return rejections.some((rejection) => {
        const codes = rejection?.order_codes || [];
        if (!codes.includes(orderCode)) return false;
        const level = String(
          rejection?.rejection_level || ""
        ).toUpperCase();
        if (level === "CASE") return true;
        if (level === "TUBE") return true; // presence in record = rejected for that tube
        return false;
      });
    },
    isValidImageFile(file) {
      if (!file) {
        return false;
      }

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/avif",
        "image/webp",
        "image/gif",
      ];

      const allowedExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".avif",
        ".webp",
        ".gif",
      ];

      const fileName = (file.name || "").toLowerCase();

      const hasValidExtension =
        allowedExtensions.some((extension) =>
          fileName.endsWith(extension)
        );

      const hasValidMimeType =
        allowedTypes.includes(file.type);

      return hasValidMimeType || hasValidExtension;
    },
    syncExistingValuesToCommonReasons() {
      const selectedCaseReasons = [];

      Object.entries(this.caseRejectionMap).forEach(
        ([key, caseData]) => {
          if (
            this.selectedCaseMap[key] &&
            caseData.reason
          ) {
            selectedCaseReasons.push(caseData.reason);
          }
        }
      );

      const selectedTubeReasons = [];

      Object.values(this.caseRejectionMap).forEach(
        (caseData) => {
          Object.values(caseData.tubes || {}).forEach(
            (tube) => {
              if (tube.rejected && tube.reason) {
                selectedTubeReasons.push(tube.reason);
              }
            }
          );
        }
      );

      const uniqueCaseReasons = [
        ...new Set(selectedCaseReasons),
      ];

      const uniqueTubeReasons = [
        ...new Set(selectedTubeReasons),
      ];

      this.commonCaseReason =
        uniqueCaseReasons.length === 1
          ? uniqueCaseReasons[0]
          : "";

      this.commonTubeReason =
        uniqueTubeReasons.length === 1
          ? uniqueTubeReasons[0]
          : "";
    },
    handleAttachmentChange(file, fileList) {
      const rawFile = file.raw;

      if (!this.isValidImageFile(rawFile)) {
        this.validationError =
          "Only image files are allowed. Please upload JPG, JPEG, PNG, AVIF, WEBP, or GIF.";

        this.attachmentFileList = [];

        return;
      }

      this.attachmentFileList = fileList.slice(-1);

      this.validationError = "";
    },

    handleAttachmentRemove(file, fileList) {
      this.attachmentFileList = fileList;
    },
    initializeForm() {
      const selectedCaseMap = {};
      const caseRejectionMap = {};

      this.caseTypeRows.forEach((row) => {
        const caseState = this.getCaseRejectionState(
          row.case_type
        );

        // Activation mode: pre-select cases that can be activated
        // (i.e. that have at least one rejected item).
        selectedCaseMap[row.key] = this.isActivationMode
          ? this.caseHasRejectedCodes(row.case_type)
          : false;

        caseRejectionMap[row.key] = {
          case_type: row.case_type,

          is_sendout: row.is_sendout,

          reason: "",

          // Action mapped from the selected
          // case rejection reason.
          comment: "",

          tubes: {},
        };

        this.getCaseTypeTubes(row.key).forEach((tube) => {
          const tubeState = this.getTubeRejectionState(
            tube,
            row.case_type
          );

          const hasRejected =
            this.isActivationMode
              ? this.tubeHasRejectedCode(tube, row.case_type)
              : (tubeState.rejected ||
                tubeState.partial ||
                (tubeState.rejectedCodes || []).length > 0 ||
                ((tube.rejectedCodes || []).length > 0));

          caseRejectionMap[row.key].tubes[tube.tubeKey] = {
            tube_id: tube.tube_id,
            tube_name: tube.tube_name,
            tests: tube.tests || [],

            // User selection
            rejected: this.isActivationMode ? hasRejected : false,

            // Existing backend rejection state
            existingRejected: tubeState.rejected,
            existingPartial: tubeState.partial,
            rejectedCodes:
              tubeState.rejectedCodes?.length
                ? tubeState.rejectedCodes
                : tube.rejectedCodes || [],

            // Preserve these values in the state.
            // They should not be cleared when selecting/deselecting.
            reason: "",
            // comment: "",
          };
        });
      });

      this.selectedCaseMap = selectedCaseMap;
      this.caseRejectionMap = caseRejectionMap;

      this.comment = "";
      this.attachmentFileList = [];
      this.validationError = "";

      this.commonCaseReason = "";
      this.commonTubeReason = "";
    },
    isTubeSelected(caseTypeKey, tubeKey) {
      return !!(
        this.caseRejectionMap?.[caseTypeKey]?.tubes?.[tubeKey]?.rejected
      );
    },
    getTestOrderCode(test) {
      return (
        test?.title
      );
    },
    getCaseTypeTubes(caseTypeKey) {
      if (this.isActivationMode) {
        return this.buildActivationCaseTypeTubes(caseTypeKey);
      }

      const row =
        this.caseTypeRows.find(
          (item) =>
            item.key === caseTypeKey
        );

      if (!row) {
        return [];
      }

      const tubeMap = new Map();

      for (const tube of this.tubeInfo || []) {
        const tests = (tube.tests || []).filter((test) => {
          const caseTypes = Array.isArray(test.case_type)
            ? test.case_type
            : test.case_type
              ? [test.case_type]
              : [];

          const orderCode = this.getTestOrderCode(test);

          return (
            caseTypes.includes(row.case_type) &&
            (test.is_sendout === true) === row.is_sendout &&
            this.isOrderCodeActive(orderCode)
          );
        });

        if (!tests.length) {
          continue;
        }

        const tubeKey =
          tube._id ||
          tube.tube_id ||
          tube.tube_name;

        if (!tubeMap.has(tubeKey)) {
          tubeMap.set(tubeKey, {
            tubeKey,
            tube_id:
              tube.tube_id ||
              tube._id,
            tube_name:
              tube.tube_name,
            image_url:
              tube.image_url || "",
            tests: [],
          });
        }

        tubeMap
          .get(tubeKey)
          .tests
          .push(...tests);
      }

      return Array.from(
        tubeMap.values()
      );
    },
    buildActivationCaseTypeRows() {
      const seen = new Map();

      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        for (const code of (rejection.order_codes || [])) {
          const test = this.findTestByTitle(code);
          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          for (const caseType of caseTypes) {
            const isSendout = test?.is_sendout === true;
            const key = this.getCaseTypeKey(caseType, isSendout);

            if (!seen.has(key)) {
              seen.set(key, {
                key,
                case_type: caseType,
                is_sendout: isSendout,
              });
            }
          }
        }
      }

      return Array.from(seen.values());
    },
    findTubeById(tubeId) {
      return (
        (this.tubeInfo || []).find(
          (t) => (t.tube_id || t._id) === tubeId
        ) || null
      );
    },
    findTubeIdsForTitle(title) {
      const ids = [];

      for (const tube of this.tubeInfo || []) {
        const has = (tube.tests || []).some(
          (test) => test.title === title
        );

        if (has) {
          ids.push(tube.tube_id || tube._id);
        }
      }

      if (!ids.length && typeof title === "string") {
        ids.push(title);
      }

      return ids;
    },
    buildActivationCaseTypeTubes(caseTypeKey) {
      const row = this.caseTypeRows.find(
        (item) => item.key === caseTypeKey
      );

      if (!row) {
        return [];
      }

      const tubeMap = new Map();

      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        const level = String(
          rejection.rejection_level || ""
        ).toUpperCase();

        for (const code of (rejection.order_codes || [])) {
          const test = this.findTestByTitle(code);

          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          if (
            !caseTypes.includes(row.case_type) ||
            (test?.is_sendout === true) !== row.is_sendout
          ) {
            continue;
          }

          const tubeIds =
            Array.isArray(rejection.tube_ids) &&
              rejection.tube_ids.length
              ? rejection.tube_ids
              : this.findTubeIdsForTitle(code);

          for (const tubeId of tubeIds) {
            if (!tubeMap.has(tubeId)) {
              const src = this.findTubeById(tubeId);

              tubeMap.set(tubeId, {
                tubeKey: tubeId,
                tube_id: tubeId,
                tube_name: src?.tube_name || tubeId || "Unknown Tube",
                image_url: src?.image_url || "",
                rejectedCodes: [],
                tests: [],
              });
            }

            if (test) {
              tubeMap.get(tubeId).tests.push(test);
            }
          }
        }
      }

      return Array.from(tubeMap.values()).filter(
        (t) => t.tests.length
      );
    },
    caseHasRejectedCodes(caseType) {
      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        for (const code of (rejection.order_codes || [])) {
          const test = this.findTestByTitle(code);
          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          if (caseTypes.includes(caseType)) {
            return true;
          }
        }
      }

      return false;
    },
    tubeHasRejectedCode(tube, caseType) {
      const tubeId = tube?.tube_id || tube?._id || tube?.tubeKey;

      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        const level = String(
          rejection.rejection_level || ""
        ).toUpperCase();

        const codeMatchesCase = (rejection.order_codes || []).some((code) => {
          const test = this.findTestByTitle(code);
          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          return caseTypes.includes(caseType);
        });

        if (!codeMatchesCase) {
          continue;
        }

        const tubeMatches =
          (rejection.tube_ids || []).includes(tubeId) ||
          (level === "CASE" &&
            (tube.tests || []).some((t) =>
              (rejection.order_codes || []).includes(t.title)
            ));

        if (tubeMatches) {
          return true;
        }
      }

      return false;
    },
    isCaseTypeToggleDisabled(caseType) {
      if (this.isActivationMode) {
        return !this.caseHasRejectedCodes(caseType);
      }

      return (
        this.getCaseRejectionState(caseType) === "REJECTED"
      );
    },
    isTubeToggleDisabled(tube, caseType) {
      if (this.isActivationMode) {
        return !this.tubeHasRejectedCode(tube, caseType);
      }

      return this.getTubeRejectionState(
        tube,
        caseType
      ).rejected;
    },
    getExistingCaseRejectionReason(caseType) {
      const reasons = [];

      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        if (String(rejection.rejection_level || "").toUpperCase() !== "CASE") {
          continue;
        }

        const matches = (rejection.order_codes || []).some((code) => {
          const test = this.findTestByTitle(code);
          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          return caseTypes.includes(caseType);
        });

        if (matches && rejection.reason) {
          reasons.push(rejection.reason);
        }
      }

      return [...new Set(reasons)].join(", ");
    },
    getExistingTubeRejectionReason(tube, caseType) {
      const reasons = [];
      const tubeId = tube?.tube_id || tube?._id || tube?.tubeKey;

      for (const rejection of (this.orderData?.order_rejection_data || [])) {
        const level = String(
          rejection.rejection_level || ""
        ).toUpperCase();

        const codeMatchesCase = (rejection.order_codes || []).some((code) => {
          const test = this.findTestByTitle(code);
          const caseTypes = Array.isArray(test?.case_type)
            ? test.case_type
            : test?.case_type
              ? [test.case_type]
              : [];

          return caseTypes.includes(caseType);
        });

        if (!codeMatchesCase) {
          continue;
        }

        const tubeMatches =
          (rejection.tube_ids || []).includes(tubeId) ||
          (level === "CASE" &&
            (tube.tests || []).some((t) =>
              (rejection.order_codes || []).includes(t.title)
            ));

        if (tubeMatches && rejection.reason) {
          reasons.push(rejection.reason);
        }
      }

      return [...new Set(reasons)].join(", ");
    },
    formatTubeTest(test) {
      return {
        title: test.title,
        lab_order_code: test.lab_order_code,
        testgo_order_code: test.testgo_order_code,
        case_type: test.case_type,
        is_sendout: test.is_sendout === true,
      };
    },
    isCaseTypeSelected(caseTypeKey) {
      return !!this.selectedCaseMap[caseTypeKey];
    },
    toggleAllCaseTypes(value) {
      this.caseTypeRows.forEach((row) => {
        if (this.isActivationMode) {
          if (this.caseHasRejectedCodes(row.case_type)) {
            this.toggleCaseType(row.key, value);
          }
          return;
        }

        if (
          this.getCaseRejectionState(row.case_type) !== "REJECTED"
        ) {
          this.toggleCaseType(row.key, value);
        }
      });
    },
    toggleCaseType(caseTypeKey, value) {
      const caseData = this.caseRejectionMap[caseTypeKey];

      if (!caseData) {
        return;
      }

      this.selectedCaseMap = {
        ...this.selectedCaseMap,
        [caseTypeKey]: value,
      };

      if (!value) {
        caseData.reason = "";
        caseData.comment = "";

        Object.values(caseData.tubes || {}).forEach((tube) => {
          tube.rejected = false;
          tube.reason = "";
        });

        return;
      }

      Object.values(caseData.tubes || {}).forEach((tube) => {
        if (this.isActivationMode) {
          // Only previously-rejected tubes can be toggled for activation.
          if (!this.tubeHasRejectedCode(tube, caseData.case_type)) {
            return;
          }
          tube.rejected = value;
          return;
        }

        // Do not touch already rejected tubes
        if (tube.existingRejected) {
          return;
        }

        // Case selection controls all active tubes
        tube.rejected = value;

        // When selecting again, preserve previous values.
        // Only apply common reason if no reason already exists.
        // if (
        //   value &&
        //   this.reasonMode === "same" &&
        //   !tube.reason &&
        //   this.commonTubeReason
        // ) {
        //   tube.reason = this.commonTubeReason;
        // }
        if (
          value &&
          this.reasonMode === "same" &&
          this.commonCaseReason
        ) {
          if (!caseData.reason) {
            caseData.reason =
              this.commonCaseReason;
          }

          if (!caseData.comment) {
            caseData.comment =
              this.reasonToActionMap[
              this.commonCaseReason
              ] || "";
          }
        }
      });

      if (
        !this.isActivationMode &&
        value &&
        this.reasonMode === "same" &&
        !caseData.reason &&
        this.commonCaseReason
      ) {
        caseData.reason = this.commonCaseReason;
      }

      if (
        !this.isActivationMode &&
        value &&
        this.reasonMode === "same"
      ) {
        this.applyCommonCaseReason();
        this.applyCommonTubeReason();
      }
    },
    // applyCommonCaseReason() {
    //   Object.entries(this.caseRejectionMap).forEach(
    //     ([caseTypeKey, caseData]) => {
    //       if (this.selectedCaseMap[caseTypeKey]) {
    //         caseData.reason = this.commonCaseReason;
    //       }
    //     }
    //   );
    // },
    applyCommonCaseReason() {
      Object.entries(
        this.caseRejectionMap
      ).forEach(
        ([caseTypeKey, caseData]) => {
          const hasSelectedTube = Object.values(
            caseData.tubes || {}
          ).some((tube) => tube.rejected);

          if (
            this.selectedCaseMap[
            caseTypeKey
            ] || hasSelectedTube
          ) {
            caseData.reason =
              this.commonCaseReason;

            caseData.comment =
              this.reasonToActionMap[
              this.commonCaseReason
              ] || "";
          }
        }
      );
    },
    applyCommonTubeReason() {
      Object.values(this.caseRejectionMap).forEach(
        (caseData) => {
          Object.values(caseData.tubes || {}).forEach(
            (tube) => {
              if (tube.rejected) {
                tube.reason = this.commonTubeReason;
              }
            }
          );
        }
      );
    },
    syncTubeReasons(caseTypeKey) {
      const row = this.caseRejectionMap[caseTypeKey];
      if (!row) return;
      Object.keys(row.tubes).forEach((tubeKey) => {
        if (!row.tubes[tubeKey].reason) {
          row.tubes[tubeKey].reason = row.reason;
        }
      });
    },
    toggleTube(caseTypeKey, tubeKey, value) {
      const caseData = this.caseRejectionMap[caseTypeKey];

      if (!caseData?.tubes?.[tubeKey]) {
        return;
      }

      const tube = caseData.tubes[tubeKey];

      if (this.isActivationMode) {
        tube.rejected = value;

        // Update case selection: selected when all
        // previously-rejected tubes are selected for activation.
        const selectableTubes = Object.values(
          caseData.tubes
        ).filter((t) =>
          this.tubeHasRejectedCode(t, caseData.case_type)
        );

        const allSelected =
          selectableTubes.length > 0 &&
          selectableTubes.every((t) => t.rejected);

        this.selectedCaseMap = {
          ...this.selectedCaseMap,
          [caseTypeKey]: allSelected,
        };

        return;
      }

      tube.rejected = value;

      if (!value) {
        tube.reason = "";
      }

      // If Same Reason mode is active,
      // apply common tube reason to newly selected tubes
      if (
        value &&
        this.reasonMode === "same" &&
        !tube.reason &&
        this.commonTubeReason
      ) {
        tube.reason =
          this.commonTubeReason;
      }

      // Update case selection based on active tube selection
      const selectableTubes = Object.values(
        caseData.tubes
      ).filter((t) => !t.existingRejected);

      const allSelected =
        selectableTubes.length > 0 &&
        selectableTubes.every((t) => t.rejected);

      this.selectedCaseMap = {
        ...this.selectedCaseMap,
        [caseTypeKey]: allSelected,
      };

      if (
        this.reasonMode === "same" &&
        value
      ) {
        this.applyCommonCaseReason();
      }

      if (!allSelected) {
        caseData.reason = "";
        caseData.comment = "";
      }
    },

    validateForm() {
      const attachment =
        this.attachmentFileList?.[0]?.raw;

      if (!attachment) {
        return "Please upload a rejection image before submitting.";
      }
      if (
        this.attachmentFileList.length > 5
      ) {
        return "You can upload a maximum of 5 images.";
      }
      if (!this.isValidImageFile(attachment)) {
        return "Only image files are allowed (JPG, JPEG, PNG, AVIF, WEBP, GIF).";
      }

      const selectedCaseKeys =
        this.selectedCaseTypeKeys;

      const selectedTubeCount =
        Object.values(this.caseRejectionMap)
          .reduce((count, caseData) => {
            return (
              count +
              Object.values(caseData.tubes || {})
                .filter((tube) => tube.rejected)
                .length
            );
          }, 0);

      if (
        !selectedCaseKeys.length &&
        !selectedTubeCount
      ) {
        return "Select at least one case type or tube to reject.";
      }

      for (const key of selectedCaseKeys) {
        const row =
          this.caseRejectionMap[key];

        if (!row.reason) {
          return `Select a rejection reason for ${this.formatCaseType(
            row.case_type
          )}.`;
        }
      }

      for (const key of Object.keys(
        this.caseRejectionMap
      )) {
        const row =
          this.caseRejectionMap[key];

        const rejectedTubes =
          Object.values(row.tubes || {})
            .filter((tube) => tube.rejected);

        for (const tube of rejectedTubes) {
          if (!tube.reason) {
            return `Select a rejection reason for ${tube.tube_name}.`;
          }
        }
      }

      return "";
    },
    submitReject() {
      if (this.isSubmitPending) {
        return;
      }

      if (this.isActivationMode) {
        this.submitActivate();
        return;
      }
      this.validationError = this.validateForm();

      if (this.validationError) {
        return;
      }

      this.submitPending = true;

      const caseTypes = [];

      Object.keys(this.caseRejectionMap).forEach((key) => {
        const row = this.caseRejectionMap[key];

        const caseSelected =
          this.selectedCaseMap[key] === true;

        const allCaseTubes =
          this.getCaseTypeTubes(key);

        const buildTubePayload = (tube) => {
          const tubeFormState =
            row.tubes?.[tube.tubeKey];

          if (!tubeFormState) {
            return null;
          }

          const existingRejectedCodes = new Set(
            tubeFormState.rejectedCodes || []
          );

          const orderCodes = (tube.tests || [])
            .map((test) => this.getTestOrderTitle(test))
            .filter(Boolean)
            .filter(
              (title) =>
                !existingRejectedCodes.has(title)
            );

          if (!orderCodes.length) {
            return null;
          }

          /**
           * SAME MODE:
           * Backend will apply common reason.
           *
           * DIFFERENT MODE:
           * Send individual tube reason.
           */
          const rejectionReason =
            this.reasonMode === "same"
              ? this.commonTubeReason
              : tubeFormState.reason;

          if (!rejectionReason) {
            return null;
          }

          return {
            tube_id: tube.tube_id,

            tube_name: tube.tube_name,

            status: "Rejected",

            rejection_reason:
              this.reasonMode === "different"
                ? rejectionReason
                : undefined,

            // comment:
            //   tubeFormState.comment || "",

            order_codes: [
              ...new Set(orderCodes),
            ],
          };
        };

        let rejectedTubes = [];

        /**
         * CASE LEVEL REJECTION
         */
        if (caseSelected) {
          rejectedTubes = allCaseTubes
            .map((tube) =>
              buildTubePayload(tube)
            )
            .filter(Boolean);
        } else {
          /**
           * TUBE LEVEL REJECTION
           */
          rejectedTubes = allCaseTubes
            .filter(
              (tube) =>
                row.tubes?.[
                  tube.tubeKey
                ]?.rejected === true
            )
            .map((tube) =>
              buildTubePayload(tube)
            )
            .filter(Boolean);
        }

        /**
         * Nothing selected.
         */
        if (
          !caseSelected &&
          !rejectedTubes.length
        ) {
          return;
        }

        /**
         * Case order codes only when
         * the complete case is rejected.
         */
        const orderCodes = caseSelected
          ? [
            ...new Set(
              rejectedTubes.flatMap(
                (tube) =>
                  tube.order_codes || []
              )
            ),
          ]
          : [];
        caseTypes.push({
          case_type: row.case_type,

          case_type_label:
            this.formatCaseType(
              row.case_type
            ),

          is_sendout:
            row.is_sendout,

          is_rejected:
            caseSelected,

          rejection_reason:
            this.reasonMode === "different" &&
              caseSelected
              ? row.reason
              : undefined,

          // Case-level action/comment
          comment:
            caseSelected
              ? row.comment || ""
              : "",

          order_codes:
            orderCodes,

          tubes:
            rejectedTubes,
        });
      });

      if (!caseTypes.length) {
        this.validationError =
          "Select at least one case type or tube to reject.";

        return;
      }

      /**
       * Build payload according to
       * EXISTING BACKEND CONTRACT.
       */
      const payload = {
        order_id:
          this.orderData?._id,

        order_number:
          this.orderData?.order_id,

        status:
          "REJECTED",

        reason_mode:
          this.reasonMode,

        /**
         * SAME MODE:
         * Common reasons are sent here.
         *
         * DIFFERENT MODE:
         * These can remain empty because
         * individual reasons are inside
         * case_types and tubes.
         */
        case_rejection_reason:
          this.reasonMode === "same"
            ? this.commonCaseReason
            : undefined,

        tube_rejection_reason:
          this.reasonMode === "same"
            ? this.commonTubeReason
            : undefined,

        case_types: caseTypes,

        comments:
          this.comment,

        images:
          // this.attachmentFileList?.[0]?.raw || null,
          this.attachmentFileList.map((file) => file.raw || file).filter(Boolean),
      };
      console.log(
        "Submitting rejection payload:",
        payload
      );
      this.$emit("submit", payload);
    },
    submitActivate() {
      const activationData = [];
      let fullCaseActivationCount = 0;

      Object.keys(this.caseRejectionMap).forEach((key) => {
        const row = this.caseRejectionMap[key];
        const caseSelected = this.selectedCaseMap[key] === true;

        const allCaseTubes = this.getCaseTypeTubes(key);

        const buildTubeActivation = (tube) => {
          const tubeFormState = row.tubes?.[tube.tubeKey];

          if (!tubeFormState || tubeFormState.rejected !== true) {
            return null;
          }

          const tubeId =
            tube.tube_id || tube._id || tube.tubeKey;

          const orderCodes = (tube.tests || [])
            .map((test) => this.getTestOrderTitle(test))
            .filter(Boolean);

          if (!orderCodes.length) {
            return null;
          }

          return {
            tube_id: tubeId,
            tube_name: tube.tube_name || tubeId,
            order_codes: [...new Set(orderCodes)],
          };
        };

        let activatedTubes = [];

        if (caseSelected) {
          activatedTubes = allCaseTubes
            .map((tube) => buildTubeActivation(tube))
            .filter(Boolean);

          if (activatedTubes.length) {
            fullCaseActivationCount += 1;
          }
        } else {
          activatedTubes = allCaseTubes
            .filter(
              (tube) =>
                row.tubes?.[tube.tubeKey]?.rejected === true
            )
            .map((tube) => buildTubeActivation(tube))
            .filter(Boolean);
        }

        if (!activatedTubes.length) {
          return;
        }

        const orderCodes = [
          ...new Set(
            activatedTubes.flatMap(
              (tube) => tube.order_codes || []
            )
          ),
        ];

        activationData.push({
          case_type: row.case_type,
          order_codes: orderCodes,
          tubes: activatedTubes.map((tube) => ({
            tube_id: tube.tube_id,
            tube_name: tube.tube_name,
          })),
        });
      });

      if (!activationData.length) {
        this.validationError =
          "Select at least one case type or tube to activate.";
        return;
      }

      const fileCount = this.attachmentFileList.length;

      if (fileCount < 1) {
        this.validationError =
          "Upload at least 1 image to proceed.";
        return;
      }

      if (fileCount > 5) {
        this.validationError =
          "You can upload a maximum of 5 images.";
        return;
      }

      /*
       * CASE: a single, fully-selected case is activated.
       * TUBE: multiple cases, or a single case activated by tubes only.
       */
      const activationLevel =
        activationData.length === 1 &&
          fullCaseActivationCount === 1
          ? "CASE"
          : "TUBE";

      const payload = {
        order_id: this.orderData?._id,
        status: "ACTIVE",
        activation_level: activationLevel,
        comments: this.comment,
        activation_data: activationData,
        images: this.attachmentFileList
          .map((file) => file.raw || file)
          .filter(Boolean),
      };

      console.log(
        "Submitting activation payload:",
        payload
      );

      this.submitPending = true;
      this.$emit("submit", payload);
    },
    normalizeRejectionData() {
      const normalized = {
        cases: {},
        tubes: {},
      };

      /*
       * Existing legacy rejection data
       */
      const samplesWithIssues =
        this.orderData?.samples_with_issues || [];

      for (const issue of samplesWithIssues) {
        if (
          String(issue?.status || "")
            .toUpperCase() !== "REJECTED"
        ) {
          continue;
        }

        const level =
          String(
            issue.rejection_level || ""
          ).toUpperCase();

        if (level === "CASE") {
          const caseType =
            issue.case_type;

          if (!caseType) continue;

          if (!normalized.cases[caseType]) {
            normalized.cases[caseType] = {
              rejected: true,
              orderCodes: new Set(),
              reasons: [],
              comments: [],
            };
          }

          if (issue.reason) {
            normalized.cases[caseType]
              .reasons
              .push(issue.reason);
          }

          if (issue.comment) {
            normalized.cases[caseType]
              .comments
              .push(issue.comment);
          }
        }

        if (level === "TUBE") {
          const tubeId =
            issue.tube_id;

          if (!tubeId) continue;

          if (!normalized.tubes[tubeId]) {
            normalized.tubes[tubeId] = {
              orderCodes: new Set(),
              reasons: [],
              comments: [],
            };
          }

          if (issue.reason) {
            normalized.tubes[tubeId]
              .reasons
              .push(issue.reason);
          }

          if (issue.comment) {
            normalized.tubes[tubeId]
              .comments
              .push(issue.comment);
          }

          (issue.tests || [])
            .map(
              (test) =>
                typeof test === "string"
                  ? test
                  : test.title
            )
            .filter(Boolean)
            .forEach((title) => {
              normalized.tubes[tubeId]
                .orderCodes
                .add(title);
            });
        }
      }

      /*
       * New order_rejection_data
       */
      const rejectionData =
        this.orderData?.order_rejection_data || [];

      for (const rejection of rejectionData) {
        const level =
          String(
            rejection.rejection_level || ""
          ).toUpperCase();

        const orderCodes = [
          ...new Set(
            (rejection.order_codes || [])
              .filter(Boolean)
              .map(String)
          ),
        ];

        /*
         * CASE
         */
        if (level === "CASE") {
          /*
           * We don't have to identify the case
           * from lab_order_code.
           *
           * The case can be resolved from the
           * test title against tubeInfo.
           */
          for (const title of orderCodes) {
            const test =
              this.findTestByTitle(title);

            const caseTypes =
              Array.isArray(test?.case_type)
                ? test.case_type
                : test?.case_type
                  ? [test.case_type]
                  : [];

            for (const caseType of caseTypes) {
              if (!normalized.cases[caseType]) {
                normalized.cases[caseType] = {
                  rejected: true,
                  orderCodes: new Set(),
                  reasons: [],
                  comments: [],
                };
              }

              normalized.cases[caseType]
                .rejected = true;

              normalized.cases[caseType]
                .orderCodes
                .add(title);

              if (rejection.reason) {
                normalized.cases[caseType]
                  .reasons
                  .push(rejection.reason);
              }

              if (rejection.comment) {
                normalized.cases[caseType]
                  .comments
                  .push(rejection.comment);
              }
            }
          }
        }

        /*
         * TUBE
         */
        if (level === "TUBE") {
          const tubeIds =
            rejection.tube_ids || [];

          for (const tubeId of tubeIds) {
            if (!normalized.tubes[tubeId]) {
              normalized.tubes[tubeId] = {
                orderCodes: new Set(),
                reasons: [],
                comments: [],
              };
            }

            orderCodes.forEach((title) => {
              normalized.tubes[tubeId]
                .orderCodes
                .add(title);
            });

            if (rejection.reason) {
              normalized.tubes[tubeId]
                .reasons
                .push(rejection.reason);
            }

            if (rejection.comment) {
              normalized.tubes[tubeId]
                .comments
                .push(rejection.comment);
            }
          }
        }
      }

      return normalized;
    },
    findTestByTitle(title) {
      for (const tube of this.tubeInfo || []) {
        for (const test of tube.tests || []) {
          if (test.title === title) {
            return test;
          }
        }
      }

      return null;
    },
    onClose() {
      this.$emit("close");
    },
    isBackendTubeRejected(tube, caseType) {
      if (!tube) {
        return false;
      }

      const tubeId =
        tube.tube_id || tube._id;

      if (!tubeId) {
        return false;
      }

      const rejection =
        this.rejectionState.tubes[tubeId];

      if (!rejection) {
        return false;
      }

      /*
      * Only consider the tube rejected for this
      * case when this case's tests are rejected.
      */
      const caseTests = (tube.tests || [])
        .filter(test => {
          const caseTypes = Array.isArray(test.case_type)
            ? test.case_type
            : [test.case_type];

          return caseTypes.includes(caseType);
        })
        .map(test =>
          test.testgo_order_code ||
          test.lab_order_code ||
          test.title
        )
        .filter(Boolean);

      return caseTests.some(code =>
        rejection.orderCodes.has(code)
      );
    },
    getTestOrderTitle(test) {
      return test?.title;
    },
    getTubeRejectionState(tube, caseType) {
      const tubeId =
        tube?.tube_id ||
        tube?._id ||
        tube?.tubeKey;

      if (!tubeId) {
        return {
          rejected: false,
          partial: false,
          rejectedCodes: [],
          reasons: [],
        };
      }

      const tubeRejection =
        this.rejectionState?.tubes?.[
        tubeId
        ];

      if (!tubeRejection) {
        return {
          rejected: false,
          partial: false,
          rejectedCodes: [],
          reasons: [],
        };
      }

      const rejectedOrderCodes = new Set(
        (this.getCaseInformation?.order_rejection_data || [])
          .flatMap(item => item.order_codes || [])
          .map(code => String(code).trim().toLowerCase())
      );

      /*
       * Only tests belonging to this
       * case type are considered.
       */
      const caseTests =
        (tube.tests || []).filter((test) => {
          const caseTypes =
            Array.isArray(test.case_type)
              ? test.case_type
              : test.case_type
                ? [test.case_type]
                : [];

          return caseTypes.includes(
            caseType
          );
        });

      const caseTitles =
        caseTests
          .map((test) =>
            this.getTestOrderTitle(test)
          )
          .filter(Boolean);

      const rejectedCodes =
        caseTitles.filter((title) =>
          rejectedOrderCodes.has(title)
        );

      if (!rejectedCodes.length) {
        return {
          rejected: false,
          partial: false,
          rejectedCodes: [],
          reasons:
            tubeRejection.reasons || [],
        };
      }

      return {
        rejected:
          rejectedCodes.length ===
          caseTitles.length,

        partial:
          rejectedCodes.length <
          caseTitles.length,

        rejectedCodes,

        reasons:
          tubeRejection.reasons || [],
      };
    },
    getCaseRejectionState(caseType) {
      /*
       * Aggregate every test title that has been
       * rejected for this case across both
       * samples_with_issues and order_rejection_data
       * (CASE level and TUBE level).
       */
      const state = this.rejectionState || { cases: {}, tubes: {} };
      const caseRejection = state.cases?.[caseType];
      const caseOrderCodesSet =
        caseRejection?.orderCodes instanceof Set
          ? caseRejection.orderCodes
          : new Set(caseRejection?.orderCodes || []);

      /*
       * Find all tests belonging to this case
       * from the bulk tube info.
       */
      const caseTests = (this.tubeInfo || [])
        .flatMap((tube) => tube.tests || [])
        .filter((test) => {
          const caseTypes = Array.isArray(test.case_type)
            ? test.case_type
            : test.case_type
              ? [test.case_type]
              : [];

          return caseTypes.includes(caseType);
        });

      /*
       * Get TEST TITLES.
       *
       * order_rejection_data stores title,
       * NOT lab_order_code.
       */
      const caseOrderCodes = [
        ...new Set(
          caseTests
            .map((test) => this.getTestOrderTitle(test))
            .filter(Boolean)
        ),
      ];

      if (!caseOrderCodes.length) {
        return "ACTIVE";
      }

      /*
       * Build a per-case set of rejected titles from
       * every tube-level entry whose tests include this
       * case (so a tube rejection against a different
       * case using the same physical tube is ignored).
       */
      const tubeRejectedTitles = new Set();
      for (const tube of this.tubeInfo || []) {
        const tubeId = tube?.tube_id || tube?._id;
        if (!tubeId) continue;

        const tubeState = state.tubes?.[tubeId];
        if (!tubeState) continue;

        /*
         * Only count titles that actually belong
         * to this case on this tube.
         */
        const tubeCaseTitles = (tube.tests || [])
          .filter((test) => {
            const caseTypes = Array.isArray(test.case_type)
              ? test.case_type
              : test.case_type
                ? [test.case_type]
                : [];
            return caseTypes.includes(caseType);
          })
          .map((test) => this.getTestOrderTitle(test))
          .filter(Boolean);

        const rejectedCodes = tubeState.orderCodes instanceof Set
          ? tubeState.orderCodes
          : new Set(tubeState.orderCodes || []);

        tubeCaseTitles.forEach((title) => {
          if (rejectedCodes.has(title)) {
            tubeRejectedTitles.add(title);
          }
        });
      }

      /*
       * Merge rejected titles from case-level
       * and tube-level sources.
       */
      const mergedRejected = new Set([
        ...caseOrderCodesSet,
        ...tubeRejectedTitles,
      ]);

      const rejectedCount = caseOrderCodes.filter((title) =>
        mergedRejected.has(title)
      ).length;

      if (rejectedCount === 0) {
        return "ACTIVE";
      }

      if (rejectedCount === caseOrderCodes.length) {
        return "REJECTED";
      }

      return "PARTIAL";
    },
  },
};
</script>
<style lang="scss">
.order-reject-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 14px 0 18px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e6edf5;
  border-radius: 6px;
}

.order-activation-summary {
  margin: 0 0 14px;
  padding: 12px 14px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 6px;
  color: #7c2d12;
  font-size: 13px;
  line-height: 1.5;
}

.tube-existing-reason {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.summary-label {
  display: block;
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 4px;
}

.summary-value {
  color: #1f2937;
  font-weight: 600;
}

.order-reject-loading {
  padding: 40px 0;
  text-align: center;
  color: #6b7280;
}

.order-reject-submit-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 210px;
  color: #409eff;
  font-weight: 600;
}

.order-reject-submit-loading .el-icon-loading {
  font-size: 22px;
}

.order-reject-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.same-reason-panel {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;

  & label {
    font-weight: 800;
    margin-right: 6px;
    font-size: 14px;
    display: block;
  }
}

.case-type-name {
  font-weight: 600;
  color: #172554;
  margin-bottom: 4px;
}

.tube-chip-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tube-chip {
  background: #eef2ff;
  color: #1e3a8a;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 600;
}

.empty-text {
  color: #9ca3af;
}

.tube-rejection-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tube-rejection-row {
  display: grid;
  grid-template-columns: 160px 245px minmax(180px, 1fr);
  gap: 2px;
  align-items: center;
}

.tube-rejection-row.disabled {
  opacity: 0.6;
}

.tube-name {
  font-weight: 600;
}

.order-reject-comment {
  margin-top: 14px;
}

.order-reject-comment label,
.order-reject-attachments label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
}

.order-reject-attachments {
  margin-top: 14px;
}

.order-reject-upload {
  max-width: 520px;
}

.order-reject-error {
  margin-top: 10px;
  color: #f24a55;
  font-weight: 600;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.case-rejection-details {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.case-detail-field {
  flex: 1;
  min-width: 0;
}

.case-detail-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
}

.case-detail-field .el-select,
.case-detail-field .el-textarea {
  width: 100%;
}
/*
 * Element Plus Dialog
 *
 * This is intentionally NOT scoped because el-dialog
 * is teleported outside the component DOM.
 */

.order-reject-dialog,
.order-reject-dialog-wrapper .el-dialog {
  padding: 20px;
  box-sizing: border-box;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 20px 10px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}

@media (max-width: 900px) {
  .order-reject-summary {
    grid-template-columns: 1fr;
  }

  .tube-rejection-row {
    grid-template-columns: 1fr;
  }
}

.rejection-table {
  .el-table__cell {
    vertical-align: middle;
  }

  .cell {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .case-rejection-details {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 4px 0;
  }

  .case-reason-select {
    width: 100%;

    .el-input__inner {
      min-height: 40px;
    }
  }

  .case-action-textarea {
    width: 100%;

    .el-textarea__inner {
      min-height: 52px !important;
      padding: 8px 10px;
      line-height: 1.4;
      resize: vertical;
    }
  }

  .tube-rejection-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    padding: 4px 0;
  }

  .tube-item {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .tube-name {
    font-size: 13px;
    font-weight: 600;
    color: #42698f;
  }

  .tube-reason-select {
    width: 220px;
  }

  .case-rejection-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 0;
    width: 100%;
  }

  .case-rejection-row {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: flex-start;
    width: 100%;
  }

  .case-rejection-field {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    /* Prevents overflow */
  }

  .field-label {
    font-size: 12px;
    font-weight: 600;
    color: #606266;
    letter-spacing: 0.3px;
  }

  .case-reason-select {
    width: 100%;

    .el-input__inner {
      min-height: 32px;
    }
  }

  .case-action-textarea {
    width: 100%;

    .el-textarea__inner {
      min-height: 32px !important;
      padding: 6px 10px;
      line-height: 1.4;
      resize: none;
      background-color: #f5f7fa;
      font-size: 13px;
    }
  }

  /* Responsive: Stack on smaller screens */
  @media (max-width: 768px) {
    .case-rejection-row {
      flex-direction: column;
      gap: 8px;
    }

    .case-rejection-field {
      width: 100%;
    }
  }
}
</style>
